import {VStack} from 'platform/foundation';

import {ListFeatures} from '../../components/ListFeatures/ListFeatures';
import {Section} from '../../components/Section/Section';
import {Separator} from '../../components/Separator/Separator';
import {i18n} from '../../i18n/i18n';
import {HistoryCheckDataSources} from './components/HistoryCheckDataSources';
import {getHistoryChecks} from './utils/getHistoryChecks';

export function HistoryCheck() {
  return (
    <Section
      id="HISTORY_CHECK"
      icon="historyCheck"
      heading={i18n.t('historyCheck.title')}
      content={
        <VStack spacing={[4, 6, 6, 10]}>
          <ListFeatures
            columns={[1, 2, 2, 2]}
            spacing={[4, 6, 6, 10]}
            features={getHistoryChecks()}
            data-testid="historyCheck"
          />
          <Separator />
          <HistoryCheckDataSources data-testid="historyCheck" />
        </VStack>
      }
    />
  );
}
